import { format } from 'date-fns';
import z from 'zod';

const baseDate = z.coerce.date({ invalid_type_error: 'Please enter a valid date' });
const transform = (date) => (date ? format(new Date(date), 'MM-dd-yyyy') : null);

export const date = baseDate.transform(transform);

export const dateBeforeToday = baseDate
  .max(new Date(), `Please enter a date before today's date`)
  .transform(transform);

export const pastDateTimeValidation = z.coerce
  .date({ invalid_type_error: 'Please enter a valid date' })
  .min(new Date('01/01/1600'), 'Please enter a valid date')
  .max(new Date(Date.now() + 1800000), 'Date cannot be in the future') // Half hour to account for a delay in user submissions
  .nullish();

export const dateStringOrDate = z.union([
  baseDate,
  z.string().refine(
    (val) => {
      const date = new Date(val);
      return !isNaN(date.getTime());
    },
    { message: 'Please enter a valid date' }
  ),
]);
